<template>
    <v-container
            id="create-customer"
            fluid
            tag="section"
    >
        <filter-form :filterForm="filterForm" />
        <base-material-card outlined icon="mdi-account-outline" class="overflow-visible pb-7">
            <template v-slot:after-heading>
                <template v-if="errorMessage">
                    <v-alert
                            type="error"
                    >
                        {{ errorMessage }}
                    </v-alert>
                </template>
                <div class="font-weight-light card-title mt-2">
                    Nhân viên xuất sắc
                </div>
            </template>
            <div class="mt-7 px-7">
                <v-row>
                    <v-col cols="12" md="6">
                        <best-employee-list class="init-revenue mt-0" title="Doanh thu khởi tạo" v-if="!loading" :datas="_.get(datas, 'turnOverInit', [])"/>
                    </v-col>
                    <v-col cols="12" md="6">
                        <best-employee-list class="success-revenue mt-0" title="Doanh thu thành công" v-if="!loading" :datas="_.get(datas, 'turnOverSuccess', [])" />
                    </v-col>
                    <!-- <v-col cols="12" md="4">
                        <best-employee-list class="latch-ratios mt-0" title="Tỉ lệ chốt" v-if="!loading" :datas="_.get(datas, 'latchRatios', []).map(d => ({...d, totalAmount: d.latchRatio}))"/>
                    </v-col> -->
                </v-row>
            </div>
        </base-material-card>
    </v-container>
</template>
<script>
    import FilterForm from './components/FilterForm.vue'
    import BestEmployeeList from './components/BestEmployeeList'
    import { formatDate } from '@/helpers/utils'
    import RepositoryFactory from "@/repositories/RepositoryFactory";
    const ReportRepository = RepositoryFactory.get('report');
    import * as moment from 'moment'
    export default {
        components: { BestEmployeeList, FilterForm },
        data() {
            return {
                filterForm: {
                    dateRange: {
                        startDate: moment().startOf('month').format('YYYY-MM-DD'),
                        endDate: moment().endOf('month').format('YYYY-MM-DD'),
                    },
                },
                datas: {},
                errorMessage: '',
                loading: false,
            }
        },
        created () {
            this.getReportEmployees()
            Bus.$on('best-employees-list-filter-thpt', (filterForm) => {
                this.filterForm = filterForm
                this.getReportEmployees()
            })
        },
        methods: {
            async getReportEmployees() {
                this.loading = true
                const params = {
                    startDateTime:  moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
                    endDateTime:  moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
                    limit: 200,
                    schoolLevelIds: [2]
                }
                const loader = this.$loading.show()
                const response = await ReportRepository.bestEmployees(params)
                loader.hide()
                // this.loading = false
                if (response.success) {
                    this.datas = _.get(response, 'data', {})
                }
                this.loading = false
            }
        }
    }
</script>
